import { axios } from '@/lib/axios';

import { Product } from '../type';

export const addItemToCart = async (product: Product, cartId: number | null) => {
    const { success, data, message } = await axios.post(
        cartId ? `v1/add-to-cart?cart_group_id=${cartId}` : `v1/add-to-cart`,
        product
    );
    
    return data.cart.cart_group_id;
};
